import * as React from "react";

import { valueIsDefined } from "lib/helpers";

interface Props {
  value: string | number;
  prefix?: string;
  suffix?: string;
  text: string;
}

export class ValuationMetric extends React.Component<Props> {
  public constructor(props: Props) {
    super(props);
  }

  public render() {
    const { value, text, prefix, suffix } = this.props;

    return (
      <div className="valuation-metric">
        <div>
          {prefix && <label className="prefix">{prefix}</label>}
          <label>{value}</label>
          {suffix && <label className="suffix">{suffix}</label>}
        </div>
        <label>{text}</label>
      </div>
    );
  }
}

interface OptionalMetricProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dependencies: any[];
  value: () => string | number;
  text: string | (() => string);
  prefix?: string;
  suffix?: string;
}

export class OptionalValuationMetric extends React.Component<OptionalMetricProps> {
  protected shouldRender: boolean;

  public constructor(props: OptionalMetricProps) {
    super(props);
    this.shouldRender = props.dependencies.every(x => valueIsDefined(x));
  }

  public render() {
    const { value, text, prefix, suffix } = this.props;

    return (
      <>
        {this.shouldRender && (
          <ValuationMetric
            value={value()}
            text={
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              (valueIsDefined((text as any).call) && (text as any)()) ||
              (text as string)
            }
            prefix={prefix}
            suffix={suffix}
          />
        )}
      </>
    );
  }
}
